import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Map } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";

@Module
export default class MapModule extends VuexModule {

    @Action
    [Map.findAllLocation]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get("/wp-json/wp/v2/dia_diem","?per_page=100")
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
    @Action
    [Map.findLocationType]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get("/wp-json/wp/v2/genre_dia_diem")
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    /* @Action
    [Map.findConfigData]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.post("/config/findAll", {})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    } */

    /* @Action
    [Map.findAllLocation]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.post("/locations/findAll", {})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    } */

    @Action
    [Map.getIntroVideo]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get("/wp-json/custom/v1/intro-video")
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Map.findAllNews]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get("/wp-json/wp/v2/posts","?categories=1,2,7,8")
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Map.findAllEvents]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get("/wp-json/wp/v2/posts","?categories=11")
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}